import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ProfileService } from "../../profile/profile.service";
import { LocalStorageService } from "../../shared/local-storage.service";

@Component({
    selector: "app-export-data-password-dialogue",
    templateUrl: "./export-data-password-dialogue.component.html",
    styleUrls: ["./export-data-password-dialogue.component.scss"],
    standalone: false,
})
export class ExportDataPasswordDialogueComponent implements OnInit {
    public passwordFormGroup: FormGroup;

    constructor(
        private _formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<ExportDataPasswordDialogueComponent>,
        private _router: Router,
        private _profileService: ProfileService,
        private _localStorageService: LocalStorageService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.passwordFormGroup = this._formBuilder.group({
            password: ["", <any>Validators.required],
        });
    }

    ngOnInit(): void {}

    submitDialog() {
        if (this.passwordFormGroup.valid) {
            const username = this._localStorageService.getUserLocalStorageObject().username;
            this._profileService.authorize(username, this.passwordFormGroup.controls["password"].value).subscribe({
                next: (result) => {
                    this.dialogRef.close();
                    this._router.navigate(["edit-qtb"], {
                        queryParams: {
                            helicopterId: this.data.helicopterId,
                            blockId: this.data.blockId,
                            documentId: this.data.documentId,
                        },
                    });
                },
                error: (error) => this.passwordFormGroup.controls["password"].setErrors({ invalid: true }),
            });
        }
    }
}
